/* eslint-disable */
export default function init(Blockly, profile, img_path) {
    Blockly.Blocks.math = {};
    Blockly.Blocks.math.style = 'math_blocks';
    Blockly.Msg.MATH_HUE = 240;

    // Blockly.FieldAngle.CLOCKWISE = false;
    // Blockly.FieldAngle.OFFSET = 0;
    // Blockly.FieldAngle.WRAP = 180;

    Blockly.defineBlocksWithJsonArray([  // BEGIN JSON EXTRACT
        // Block for numeric value.
        {
          "type": "math_number",
          "message0": "%1",
          "args0": [{
            "type": "field_number",
            "name": "NUM",
            "value": 0
          }],
          "output": "Number",
          "helpUrl": "",
          "style": "math_blocks",
          "tooltip": "%{BKY_MATH_NUMBER_TOOLTIP}",
          "extensions": ["parent_tooltip_when_inline"]
        }
    ]);  // END JSON EXTRACT (Do not delete this comment.)

    Blockly.Blocks.math_angle = {
        init: function() {
            this.setStyle(Blockly.Blocks.math.style);
            this.setHelpUrl("");
            this.appendDummyInput("")
                .appendField(Blockly.Msg.MATH_ANGLE)
                .appendField(new Blockly.FieldAngle("90"), "ANGLE")
            this.setOutput(!0, "Number");
            this.setTooltip(Blockly.Msg.MATH_ANGLE)
        }
    };
    Blockly.Blocks.math_angle_180 = {
        init: function() {
            var validator = function(newValue) {
                if ((newValue >= 180) && (newValue <= 270)) return 180;
                else if (newValue > 270) return 0
                else return newValue;
            };

            this.setStyle(Blockly.Blocks.math.style);
            this.setHelpUrl("");
            this.appendDummyInput("")
                .appendField(Blockly.Msg.MATH_ANGLE)
                .appendField(new Blockly.FieldAngle("0", validator), "ANGLE");
            this.setOutput(!0, "Number");
            this.setTooltip(Blockly.Msg.MATH_ANGLE)
        }
    };
    Blockly.Blocks.math_to_int = {
        init: function() {
            this.setHelpUrl("");
            this.setStyle(Blockly.Blocks.math.style);
            this.appendDummyInput("").appendField(Blockly.Msg.MATH_TO_INT);
            this.appendValueInput("NUM").setCheck("Number");
            this.setInputsInline(!0);
            this.setOutput(!0, "Number");
            this.setTooltip(Blockly.Msg.MATH_TO_INT)
        }
    };
    Blockly.Blocks.math_to_uint = {
        init: function() {
            this.setHelpUrl("");
            this.setStyle(Blockly.Blocks.math.style);
            this.appendDummyInput("").appendField(Blockly.Msg.MATH_TO_UINT);
            this.appendValueInput("NUM").setCheck("Number");
            this.setInputsInline(!0);
            this.setOutput(!0, "Number");
            this.setTooltip(Blockly.Msg.MATH_TO_UINT)
        }
    };
    Blockly.Blocks.math_atan2 = {
        init: function() {
            this.setStyle(Blockly.Blocks.math.style);
            this.appendDummyInput("").appendField(Blockly.Msg.MATH_TRIG_ATAN2);
            this.appendValueInput("NUM1").setCheck("Number");
            this.appendValueInput("NUM2").setCheck("Number");
            this.setInputsInline(!0);
            this.setOutput(!0, "Number");
            this.setTooltip(Blockly.Msg.MATH_TRIG_TOOLTIP_ATAN2)
        }
    };
    Blockly.Blocks.math_arithmetic = {
        init: function() {
            var a = [
                [Blockly.Msg.MATH_ADDITION_SYMBOL, "ADD"],
                [Blockly.Msg.MATH_SUBTRACTION_SYMBOL, "MINUS"],
                [Blockly.Msg.MATH_MULTIPLICATION_SYMBOL, "MULTIPLY"],
                [Blockly.Msg.MATH_DIVISION_SYMBOL, "DIVIDE"],
                [Blockly.Msg.MATH_POWER_SYMBOL, "POWER"]
            ];
            this.setHelpUrl("");
            this.setStyle(Blockly.Blocks.math.style);
            this.setOutput(!0, "Number");
            this.appendValueInput("A").setCheck("Number");
            this.appendValueInput("B").setCheck("Number").appendField(new Blockly.FieldDropdown(a),
                "OP");
            this.setInputsInline(!0);
            var b = this;
            this.setTooltip(function() {
                var c = b.getFieldValue("OP");
                return {
                    ADD: Blockly.Msg.MATH_ARITHMETIC_TOOLTIP_ADD,
                    MINUS: Blockly.Msg.MATH_ARITHMETIC_TOOLTIP_MINUS,
                    MULTIPLY: Blockly.Msg.MATH_ARITHMETIC_TOOLTIP_MULTIPLY,
                    DIVIDE: Blockly.Msg.MATH_ARITHMETIC_TOOLTIP_DIVIDE,
                    POWER: Blockly.Msg.MATH_ARITHMETIC_TOOLTIP_POWER
                }[c]
            })
        }
    };
    Blockly.Blocks.math_single = {
        // oJo, arreglar esto, 
        // hecho - sacar todas las literales 
        // hecho - arreglar tooltips
        // falta e^ 10^
        init: function() {
            var a = [
                [Blockly.Msg.MATH_SINGLE_OP_ROOT, "ROOT"],
                [Blockly.Msg.MATH_SINGLE_OP_ABSOLUTE, "ABS"],
                [Blockly.Msg.MATH_SINGLE_OP_NEG, "NEG"],
                [Blockly.Msg.MATH_SINGLE_OP_LN, "LOG"],
                [Blockly.Msg.MATH_SINGLE_OP_LOG10, "LOG10"],
                [Blockly.Msg.MATH_SINGLE_OP_ROUND, "ROUND"],
                [Blockly.Msg.MATH_SINGLE_OP_ROUNDUP, "ROUNDUP"],
                [Blockly.Msg.MATH_SINGLE_OP_ROUNDDOWN, "ROUNDDOWN"],
                [Blockly.Msg.MATH_SINGLE_TRIG_SIN, "SIN"],
                [Blockly.Msg.MATH_SINGLE_TRIG_COS, "COS"],
                [Blockly.Msg.MATH_SINGLE_TRIG_TAN, "TAN"],
                [Blockly.Msg.MATH_SINGLE_TRIG_ASIN, "ASIN"],
                [Blockly.Msg.MATH_SINGLE_TRIG_ACOS, "ACOS"],
                [Blockly.Msg.MATH_SINGLE_TRIG_ATAN, "ATAN"]
            ];
            this.setHelpUrl("");
            this.setStyle(Blockly.Blocks.math.style);
            this.setOutput(!0, "Number");
            this.appendValueInput("NUM").setCheck("Number").appendField(new Blockly.FieldDropdown(a), "OP");
            var b = this;
            this.setTooltip(function() {
                var c = b.getFieldValue("OP");
                return {
                    ROOT: Blockly.Msg.MATH_SINGLE_TOOLTIP_ROOT,
                    ABS: Blockly.Msg.MATH_SINGLE_TOOLTIP_ABS,
                    NEG: Blockly.Msg.MATH_SINGLE_TOOLTIP_NEG,
                    LOG: Blockly.Msg.MATH_SINGLE_TOOLTIP_LN,
                    LOG10: Blockly.Msg.MATH_SINGLE_TOOLTIP_LOG10,
                    ROUND: Blockly.Msg.MATH_SINGLE_TOOLTIP_ROUND,
                    ROUNDUP: Blockly.Msg.MATH_SINGLE_TOOLTIP_ROUNDUP,
                    ROUNDDOWN: Blockly.Msg.MATH_SINGLE_TOOLTIP_ROUNDDOWN,
                    SIN: Blockly.Msg.MATH_SINGLE_TRIG_TOOLTIP_SIN,
                    COS: Blockly.Msg.MATH_SINGLE_TRIG_TOOLTIP_COS,
                    TAN: Blockly.Msg.MATH_SINGLE_TRIG_TOOLTIP_TAN,
                    ASIN: Blockly.Msg.MATH_SINGLE_TRIG_TOOLTIP_ASIN,
                    ACOS: Blockly.Msg.MATH_SINGLE_TRIG_TOOLTIP_ACOS,
                    ATAN: Blockly.Msg.MATH_SINGLE_TRIG_TOOLTIP_ATAN
                }[c]
            })
        }
    };
    Blockly.Blocks.math_change = {
        init: function() {
            this.jsonInit({
                message0: Blockly.Msg.MATH_CHANGE_TITLE,
                args0: [{
                    type: "field_variable",
                    name: "VARNUM",
                    variableTypes: ["Number"],
                    defaultType: "Number",
                    variable: Blockly.Msg.MATH_CHANGE_TITLE_ITEM
                }, {
                    type: "input_value",
                    name: "DELTA",
                    check: "Number"
                }],
                previousStatement: null,
                nextStatement: null,
                style: Blockly.Blocks.math.style,
                helpUrl: ""
            });
            var a = this;
            this.setTooltip(function() {
                var varName = Blockly.Arduino.nameDB_.getName(a.getFieldValue("VARNUM"), Blockly.VARIABLE_CATEGORY_NAME);
                return Blockly.Msg.MATH_CHANGE_TOOLTIP.replace("%1", varName.length > 17? Blockly.Msg.MATH_CHANGE_TITLE_ITEM : varName);
            })
        },
    };
    Blockly.Blocks.math_random_int = {
        init: function() {
            this.jsonInit({
                message0: Blockly.Msg.MATH_RANDOM_INT_TITLE,
                args0: [{
                    type: "input_value",
                    name: "FROM",
                    check: "Number"
                }, {
                    type: "input_value",
                    name: "TO",
                    check: "Number"
                }],
                inputsInline: !0,
                output: "Number",
                style: Blockly.Blocks.math.style,
                tooltip: Blockly.Msg.MATH_RANDOM_INT_TOOLTIP,
                helpUrl: ""
            })
        }
    };
    Blockly.Blocks.math_modulo = {
        init: function() {
            this.jsonInit({
                message0: Blockly.Msg.MATH_MODULO_TITLE,
                args0: [{
                    type: "input_value",
                    name: "DIVIDEND",
                    check: "Number"
                }, {
                    type: "input_value",
                    name: "DIVISOR",
                    check: "Number"
                }],
                inputsInline: !0,
                output: "Number",
                style: Blockly.Blocks.math.style,
                tooltip: Blockly.Msg.MATH_MODULO_TOOLTIP,
                helpUrl: ""
            })
        }
    };
    Blockly.Blocks.math_map = {
        init: function() {
            this.jsonInit({
                message0: Blockly.Msg.MATH_MAP_TITLE,
                args0: [{
                    type: "input_value",
                    name: "VALUE",
                    check: "Number"
                }, {
                    type: "input_value",
                    name: "FROMLOW",
                    check: "Number"
                }, {
                    type: "input_value",
                    name: "FROMHIGH",
                    check: "Number"
                }, {
                    type: "input_value",
                    name: "TOLOW",
                    check: "Number"
                }, {
                    type: "input_value",
                    name: "TOHIGH",
                    check: "Number"
                }],
                inputsInline: !0,
                output: "Number",
                style: Blockly.Blocks.math.style,
                tooltip: Blockly.Msg.MATH_MAP_TOOLTIP,
            })
        }
    };
    Blockly.Blocks.math_constrain = {
        init: function() {
            this.jsonInit({
                message0: Blockly.Msg.MATH_CONSTRAIN_TITLE,
                args0: [{
                    type: "input_value",
                    name: "VALUE",
                    check: "Number"
                }, {
                    type: "input_value",
                    name: "LOW",
                    check: "Number"
                }, {
                    type: "input_value",
                    name: "HIGH",
                    check: "Number"
                }],
                inputsInline: !0,
                output: "Number",
                style: Blockly.Blocks.math.style,
                tooltip: Blockly.Msg.MATH_CONSTRAIN_TOOLTIP,
                helpUrl: ""
            })
        }
    };
}